export default "{\n    \"restaurant\": \"Restaurant\",\n    \"vendor\": \"Fournisseur\"\n}\n"